/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Music_NoteInputs */



/**
* | output |
* | --- |
* | "Insert ♪" |
*
* @param {Shortcut_Keys_Name_Insert_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_music_note = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer ♪")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfügen ♪")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci ♪")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить ♪")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar ♪")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入♪")
	if (locale === "ja") return /** @type {LocalizedString} */ ("挿入♪")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सम्मिलित करें ♪")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir ♪")
	return /** @type {LocalizedString} */ ("Insert ♪")
});